// src/client/screens/borrower/LoanSuccessScreen.tsx
// Drift fix vs plan: replaced <Link><Button></Link> with useNavigate + onClick
// to match Task 12's HomeScreen fix (invalid HTML5 nested-interactive pattern).
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { CheckCircle2 } from 'lucide-react';
import { clearLoanDraft } from '@client/lib/loanDraft';
import ScreenShell from '@client/components/ScreenShell';
import Card from '@client/components/Card';
import Button from '@client/components/Button';

export default function LoanSuccessScreen() {
  const navigate = useNavigate();
  useEffect(() => { clearLoanDraft(); }, []);
  return (
    <ScreenShell title="Application received">
      <Card>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, padding: 24 }}>
          <CheckCircle2 size={56} color="var(--c-success)" aria-hidden />
          <h2>You're all set</h2>
          <p className="small" style={{ textAlign: 'center' }}>
            We'll review your application and disburse the funds to your
            registered phone within minutes once approved.
          </p>
          <div style={{ width: '100%', marginTop: 12 }}>
            <Button block size="lg" onClick={() => navigate(ROUTES.home)}>
              Back to home
            </Button>
          </div>
        </div>
      </Card>
    </ScreenShell>
  );
}
